import { render, staticRenderFns } from "./GenAIResponse.vue?vue&type=template&id=3bcc8cee&scoped=true&"
import script from "./GenAIResponse.vue?vue&type=script&lang=js&"
export * from "./GenAIResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcc8cee",
  null
  
)

export default component.exports